<template>
  <div title="Nancy" class="e-icon-settings dlg-template">{{ header }} Category</div>
</template>

<script>
import Vue from "vue";

export default {
  name: "FormsCategoryModalHeader",
  components: {},
  data() {
    return {
      header: null,
    };
  },
  methods: {
    setContent(key) {
      this.header = key;
    },
  },
};
</script>
